// src/context/UserContext.js
import { createContext, useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";

const UserContext = createContext({
  user: null,
  setUser: () => {},
  login: () => {},
  logout: () => {},
  loading: true,
});

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // To manage loading state

  // Function to handle login
  const login = (token) => {
    try {
      //console.log("Logging in with token:", token);
      const decodedToken = jwtDecode(token);
      //console.log("Decoded Token:", decodedToken);
      const userInfo = {
        username: decodedToken.username,
        name: decodedToken.name,
        role: Number(decodedToken.role),
        sub: Number(decodedToken.sub)
      };
      //console.log("Setting user info:", userInfo);
      setUser(userInfo);
      localStorage.setItem("token", token);
    } catch (error) {
      //console.error("Invalid token during login:", error);
      setUser(null);
      localStorage.removeItem("token");
    }
  };

  // Function to handle logout
  const logout = () => {
    console.log("Logging out...");
    setUser(null);
    localStorage.removeItem("token");
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    //console.log("Checking for token in localStorage:", token);

    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        //console.log("Decoded Token:", decodedToken);
        const userInfo = {
          username: decodedToken.username,
          name: decodedToken.name,
          role: Number(decodedToken.role),
          sub: Number(decodedToken.sub)
        };
        //console.log("Setting user info on mount:", userInfo);
        setUser(userInfo);
      } catch (error) {
        console.error("Invalid token during initial load:", error);
        // Handle invalid token, e.g., redirect to login
        setUser(null);
        localStorage.removeItem("token");
      }
    }
    setLoading(false); // Loading complete
  }, []);

  return (
    <UserContext.Provider value={{ user, setUser, login, logout, loading }}>
      {children}
    </UserContext.Provider>
  );
};

export default UserContext;